/**
 * 404错误页面
 */

import {
    Button,
    Result,
} from 'antd';
import CNF from './Config';

const Error404 = () => (
    <Result
        status='404'
        title='404'
        subTitle='非常抱歉，您访问的页面不翼而飞了。'
        extra={<Button type='primary' href={'/' + CNF.mainUrl ? CNF.mainUrl : ''}>返回主页</Button>}
    />
);
export default Error404;